(() => {
  const strip = document.querySelector('.dpt-search-strip');
  if (!strip) return;
  const input = strip.querySelector('input[name="q"]');
  const panel = strip.querySelector('#dpt-live-results');
  const form = strip.querySelector('form');
  if (!input || !panel || !form) return;
  // Keep the submitted search term visible on the full search-results page.
  if (/\/(?:search)\/?$/.test(window.location.pathname)) {
    const submittedTerm = new URLSearchParams(window.location.search).get('q');
    if (submittedTerm !== null) input.value = submittedTerm;
  }
  let timer, controller;
  const escapeHtml = s => String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const hide = () => { panel.hidden = true; panel.innerHTML = ''; };
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'GBP'}).format(Number(amount));
  input.addEventListener('input', () => {
    clearTimeout(timer);
    controller?.abort();
    const term = input.value.trim();
    if (term.length < 2) { hide(); return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const url = root + 'search/suggest.json?' + new URLSearchParams({'q':term,'resources[type]':'product,collection,query','resources[limit]':'10','resources[limit_scope]':'each','resources[options][unavailable_products]':'last'});
        const res = await fetch(url, {signal:controller.signal});
        if (!res.ok) throw new Error('Search unavailable');
        const data = (await res.json()).resources?.results || {};
        if (input.value.trim() !== term) return;
        let products = (data.products || []).slice(0,4);
        // Shopify's full search can find translated product titles even when
        // predictive search returns collections but no products.
        if (!products.length) {
          try {
            const searchUrl = form.action + '?' + new URLSearchParams({q:term,type:'product'});
            const searchResponse = await fetch(searchUrl, {signal:controller.signal});
            if (searchResponse.ok) {
              const doc = new DOMParser().parseFromString(await searchResponse.text(), 'text/html');
              const seen = new Set();
              const cards = [];
              for (const anchor of doc.querySelectorAll('a[href*="/products/"]')) {
                const link = new URL(anchor.getAttribute('href'), location.origin);
                const match = link.pathname.match(/\/products\/([^/]+)/);
                if (!match || seen.has(match[1])) continue;
                const card = anchor.closest('product-card, .product-card, .card, .product-grid__item, li') || anchor.parentElement;
                const titleNode = card?.querySelector('.product-card__title, .card__heading, .product-title, [class*="product-title"], h3, h2');
                const title = (titleNode?.textContent || anchor.getAttribute('aria-label') || anchor.textContent || '').trim().replace(/\s+/g, ' ');
                if (!title || title.length > 180) continue;
                seen.add(match[1]);
                const img = card?.querySelector('img');
                const priceNode = card?.querySelector('.price-item--regular, .price-item, .price, [class*="price"]');
                cards.push({url:link.pathname,title,featured_image:{url:img?.getAttribute('src') || img?.getAttribute('data-src') || ''},display_price:priceNode?.textContent?.trim() || ''});
                if (cards.length >= 4) break;
              }
              if (input.value.trim() !== term) return;
              products = cards;
            }
          } catch (fallbackError) {
            if (fallbackError.name === 'AbortError') return;
          }
        }
        const suggestions = (data.queries || []).slice(0,5);
        const collectionIndex = (() => {
          try { return JSON.parse(document.getElementById('dpt-product-collection-index')?.textContent || '{}'); }
          catch (_) { return {}; }
        })();
        const collections = [...(data.collections || [])];
        for (const product of products) {
          const handle = (product.url || '').split('/products/')[1]?.split(/[?#/]/)[0];
          for (const collection of (collectionIndex[handle] || [])) {
            if (!collections.some(item => item.url === collection.url)) collections.push(collection);
          }
        }
        const localizedPath = path => { const url = new URL(path, location.origin); const prefix = root.replace(/\/$/, ''); if (prefix && !url.pathname.startsWith(prefix + '/')) url.pathname = prefix + url.pathname; return url.pathname + url.search + url.hash; };
        const suggestionHtml = suggestions.map(x => '<a href="'+escapeHtml(localizedPath(x.url))+'">'+escapeHtml(x.text || x.styled_text?.replace(/<[^>]*>/g,''))+'</a>').join('');
        const uniqueCollections = [...new Map(collections.map(x => [new URL(x.url, location.origin).pathname.replace(/\/$/, ''), x])).values()];
        if (/\b(rod|rods|bar|bars|çubuk|cubuk)\b/i.test(term)) {
          uniqueCollections.sort((a,b) => (a.url?.includes('/collections/pdr-rods') && !a.url?.includes('/collections/pdr-rods-1') ? -1 : 0) - (b.url?.includes('/collections/pdr-rods') && !b.url?.includes('/collections/pdr-rods-1') ? -1 : 0));
        }
        const collectionHtml = uniqueCollections.slice(0,8).map(x => '<a href="'+escapeHtml(localizedPath(x.url))+'">'+escapeHtml(x.title)+'</a>').join('');
        const productsHtml = products.map(x => '<a class="dpt-live-product" href="'+escapeHtml(localizedPath(x.url))+'">'+(x.featured_image?.url ? '<img loading="lazy" src="'+escapeHtml(x.featured_image.url)+'" alt="">' : '')+'<span>'+escapeHtml(x.title)+'</span><span>'+money(x.price)+'</span></a>').join('');
        panel.innerHTML = '<a class="dpt-live-all" href="'+escapeHtml(form.action)+'?'+new URLSearchParams({q:term,type:'product'}).toString()+'">See all products →</a><div class="dpt-live-grid"><div class="dpt-live-suggestions">'+(suggestionHtml ? '<strong>Suggestions</strong>'+suggestionHtml : '')+(collectionHtml ? '<strong>Collections</strong>'+collectionHtml : '')+'</div><div><p class="dpt-live-title">Products</p><div class="dpt-live-products">'+productsHtml+'</div></div></div>';
        panel.hidden = !(products.length || suggestions.length || collections.length);
      } catch(e) { if (e.name !== 'AbortError') hide(); }
    }, 220);
  });
  document.addEventListener('pointerdown', e => { if (!strip.contains(e.target)) hide(); });
  input.addEventListener('keydown', e => { if (e.key === 'Escape') hide(); });

})();